// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}

li a {
  font-size: 16px !important;
  font-weight: bold;
  color: black;
}

li a:hover {
  color: blue;
  border-bottom: 2px solid blue;
}

.profile {
  top: 80px;
}

.card {
  width: 100%;
}

.mt-110 {
  margin-top: 110px;
}

#footer {
  background-color: #fff;
  border-top: 1px solid;
  padding-bottom: 10px;
  padding-top: 10px;
}

.collapse:not(.show) {
  display: true !important;
}

.note-p {
  color: #000;
  font-weight: bold;
  margin-bottom: 0px;
  text-decoration: none !important;
}

.note-div {
  border: 1px solid #8e0b56;
  padding: 10px;
  border-radius: 5px;
}

.note-p a {
  text-decoration: none !important;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 5px;
}

a.btn-icon-only {
  line-height: unset;
}

.card .card-blockquote {
  position: relative;
  padding: 0px 40px !important;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/website/home/home.component.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;EACA,yCAAA;AADJ;;AAGA;EACI,0BAAA;EACA,iBAAA;EACA,YAAA;AAAJ;;AAEA;EACI,WAAA;EACA,6BAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AAEJ;;AAEI;EACE,wBAAA;AACN;;AAGE;EAAQ,WAAA;EAAa,iBAAA;EAAmB,kBAAA;EAAoB,gCAAA;AAI9D;;AAHE;EAAU,yBAAA;EAAyB,aAAA;EAAe,kBAAA;AASpD;;AARE;EAAU,gCAAA;AAYZ;;AAXE;EAA8B,YAAA;AAehC;;AAdE;EAAgB,kBAAA;AAkBlB;;AAhBE;EACE,kBAAA;EACA,4BAAA;AAmBJ;AACA,ojEAAojE","sourcesContent":["\n\n.navbar {\n    background-color: #fff;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, .05);\n}\nli a{\n    font-size: 16px !important;\n    font-weight: bold;\n    color: black;\n}\nli a:hover{\n    color: blue;\n    border-bottom: 2px solid blue;\n}\n\n.profile {\n    top: 80px;\n}\n.card{\n    width: 100%;\n}\n\n.mt-110{\n    margin-top: 110px;\n}\n\n#footer{\n    background-color: #fff;\n    border-top: 1px solid;\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.collapse {\n    &:not(.show) {\n      display: true !important;\n    }\n  }\n\n  .note-p{color: #000; font-weight: bold; margin-bottom: 0px; text-decoration: none !important;}\n  .note-div{border:1px solid #8e0b56;padding: 10px; border-radius: 5px; }\n  .note-p a{text-decoration: none !important;}\n  .btn-lg, .btn-group-lg > .btn{padding: 5px;}\n  a.btn-icon-only{line-height: unset;}\n\n  .card .card-blockquote {\n    position: relative;\n    padding: 0px 40px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
